<template>
  <div class="footerr container is-gap-top color-green-bg"
    data-aos="fade-in" data-aos-once="true"
    v-loading="loading">
    <div class="is-gap is-pad-large">
      <div class="columns is-gapless is-multiline is-flex is-centered has-text-left">
        <div class="column is-12-mobile is-12-tablet is-4-desktop is-4-widescreen quick-links"
          :style="[(!isDesktop ? { marginTop: '24px' } : {})]">
          <h3>Quick Links</h3>
          <hr style="margin-bottom:12px;" />
          <div v-for="(ql, qindex) in quickLinks" :key="`${qindex}`">
            <a :href="ql.route">{{ ql.title }}</a>
          </div>
        </div>
        <div class="column is-12-mobile is-12-tablet is-5-desktop is-5-widescreen contact-info"
          :style="[(!isDesktop ? { marginTop: '24px' } : {})]">
          <h3>Contact Us</h3>
          <hr style="margin-bottom:12px;" />
          <p v-for="(cu, cindex) in contactUs" :key="`${cindex}`"
            v-html="cu.content">
          </p>
        </div>
        <div class="column is-12-mobile is-12-tablet is-3-desktop is-3-widescreen social-media"
          :style="[(!isDesktop ? { marginTop: '24px' } : {})]">
          <h3>Social Media</h3>
          <hr style="margin-bottom:12px;" />
          <div class="inline-middle" v-for="(sm, sindex) in socialMedia" :key="`${sindex}`">
            <a :href="sm.route" target="_blank" v-html="sm.content"></a>
          </div>
        </div>
      </div>
    </div>
    <div style="font-size:0.8em;background-color:white;color:black;padding-top:20px;padding-bottom:20px;">
      &copy; {{ year }} Copyright Allied instructional Services | Website by <a class="link" target="_blank" href="https://adaptconcepts.com">Adapt Concepts</a>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import EventBus from '@/controllers/EventBus'
import Util from '@/util'
import Site from '@/apis/site'

export default {
  name: 'footerr',
  components: {},
  data () {
    return {
      isDesktop: true,
      loading: false,
      hotlinks: [],
    }
  },
  computed: {
    quickLinks: function () {
      let links = Util.array.copy(this.hotlinks)
      links = _.filter(links, (item) => item.name === 'quick-links')
      links = _.orderBy(links, ['sort'], ['asc'])
      return links
    },

    contactUs: function () {
      let links = Util.array.copy(this.hotlinks)
      links = _.filter(links, (item) => item.name === 'contact-us')
      links = _.orderBy(links, ['sort'], ['asc'])
      return links
    },

    socialMedia: function () {
      let links = Util.array.copy(this.hotlinks)
      links = _.filter(links, (item) => item.name === 'social-media')
      links = _.orderBy(links, ['sort'], ['asc'])
      return links
    },

    year: function () {
      return EventBus.info.year
    },
  },
  watch: {
  },
  created () {
    // console.log('created Landing.vue')
  },
  mounted () {
    // console.log('mounted Landing.vue')
    // window.GA('send', 'pageview')
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.refresh()
  },
  methods: {
    async refresh () {
      try {
        this.$set(this, 'loading', true)
        let promises = []
        let promise
        promise = this.getBlocks()
        promises.push(promise)
        await Promise.all(promises)
        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getBlocks () {
      this.$set(this, 'hotlinks', [])
      let data = await Site.hotlinks('page-contact')
      this.$set(this, 'hotlinks', data)
    },
  }
}
</script>

<style lang="scss">
@import "../styles/base.scss";

.footerr {
  // can't use scoped for dynamic content
  .quick-links {
    a {
      display: block;
      padding-top: 2px;
      padding-bottom: 2px;
      color: white;
      &:hover {
        color: $color-primary-yellow;
      }
    }
  }

  .contact-info {
    p {
      margin-top: 2px;
      margin-bottom: 2px;
    }
    .fa {
      font-size: 1.2em;
      padding-left: 2px;
      padding-right: 12px;
    }
  }

  .social-media {
    a {
      color: white;
      &:hover {
        color: $color-primary-yellow;
      }
    }
    .fa {
      text-align: center;
      width: 42px;
      height: 42px;
      border: 2px solid white;
      border-radius: 22px;
      font-size: 1.6em;
      padding: 6px;
      margin: 6px;
    }
  }

  .link {
    &:hover, &:focus, &:active {
      color: $color-primary-green;
    }
  }
}

</style>
